export const meta = {
  title: "Mi CV | Español",
  meta: [
    { charset: "utf-8" },
    { equiv: "Content-Type", content: "text/html" },
    { name: "viewport", content: "width=device-width, initial-scale=1" },
    {
      name: "description",
      content:
        "Vittorio Retrivi - Desarrollador Full Stack JavaScript | Ingeniero en Sistemas de Información",
    },
    { name: "language", content: "es" },
    {
      name: "keywords",
      content: "Vittorio, Retrivi, CV, Curriculum Vitae, Resume, Vue, Vue.js",
    },
    { name: "author", content: "Vittorio Retrivi" },
    { name: "copyright", content: "Vittorio Retrivi" },
    { name: "theme-color", content: "#b93e36" },
  ],
};
